/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Page_DescriptionInputs */

const en_samples_page_description = /** @type {(inputs: Samples_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage customer sample requests`)
};

const es_samples_page_description = /** @type {(inputs: Samples_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar solicitudes de muestras de clientes`)
};

/**
* | output |
* | --- |
* | "Manage customer sample requests" |
*
* @param {Samples_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_page_description = /** @type {((inputs?: Samples_Page_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Page_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_page_description(inputs)
	return es_samples_page_description(inputs)
});